import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const COUPON_DEV_ONLY = false;

export let isCouponEnabled = false;

// Comente a linha abaixo para desativar a funcionalidade de cupons (checkout e Gestão de Cupons) no frontend.
isCouponEnabled = !COUPON_DEV_ONLY || isDevelopmentEnvironment;

// Regras opcionais de cupom, independentes entre si. Com todas desligadas, o cupom é de uso único,
// para qualquer cliente e sem prazo. Mantenha em sincronia com Features/CouponFeature.cs do backend.
export let isCouponMultiUseEnabled = false;
export let isCouponClientRestrictionEnabled = false;
export let isCouponValidityPeriodEnabled = false;

// Descomente a linha abaixo para permitir cupons com mais de um uso (ou ilimitados).
// isCouponMultiUseEnabled = true; // desligado: todo cupom é de uso único

// Descomente a linha abaixo para permitir cupons restritos a uma lista de clientes.
isCouponClientRestrictionEnabled = true;

// Descomente a linha abaixo para permitir cupons com período de validade.
isCouponValidityPeriodEnabled = true;
